import React, { useEffect, useContext } from "react";
import AppContext from "../contexts/AppContext";
import Header from "../components/header";

import { useHistory } from "react-router";
import { readProjectDetail } from "../actions";
import { makeStyles } from "@material-ui/core/styles";
import ListSubheader from "@material-ui/core/ListSubheader";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import ListIcon from "@material-ui/icons/List";
import PlaylistAddCheckIcon from "@material-ui/icons/PlaylistAddCheck";
import ViewWeekIcon from "@material-ui/icons/ViewWeek";
import EventNoteIcon from "@material-ui/icons/EventNote";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import Container from "@material-ui/core/Container";
import componentStyles from "../assets/styles/containers/project_detail";

import { useTranslation } from "react-i18next";

const useStyles = makeStyles(componentStyles);
const Project = (props) => {
  const { state, dispatch } = useContext(AppContext);
  const redmineurl = state.current.redmineurl;
  const apikey = state.current.apikey;
  const history = useHistory();
  const { t } = useTranslation();

  const ProjectId = props.match.params.id;
  const classes = useStyles();
  useEffect(() => {
    readProjectDetail(redmineurl, apikey, ProjectId, dispatch);
  }, []);

  return (
    <>
      <Header />

      <Container
        maxWidth={false}
        component={Box}
        marginTop="-6rem"
        classes={{ root: classes.containerRoot }}
      >
        <Grid container justify="center">
          <Grid md={12}>
            <Card classes={{ root: classes.cardRoot }}>
              <CardHeader
                className={classes.cardHeader}
                title={state.projectDetail ? state.projectDetail.name : ""}
                titleTypographyProps={{
                  component: Box,
                  marginBottom: "0!important",
                  variant: "h3",
                }}
              ></CardHeader>

              <List component="nav" className={classes.root}>
                <ListItem button>
                  <ListItemIcon>
                    <ListIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary={t("label_issues")}
                    onClick={(e) =>
                      history.push(
                        "/project/" + state.projectDetail.id + "/issues"
                      )
                    }
                  />
                </ListItem>
              </List>

              <List
                component="nav"
                subheader={
                  <ListSubheader component="div" id="nested-list-subheader">
                    Extend View
                  </ListSubheader>
                }
                className={classes.root}
              >
                <ListItem button>
                  <ListItemIcon>
                    <ViewWeekIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary="Issue Card"
                    onClick={(e) =>
                      history.push(
                        "/project/" + state.projectDetail.id + "/card"
                      )
                    }
                  />
                </ListItem>
                <ListItem button>
                  <ListItemIcon>
                    <PlaylistAddCheckIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary="Task List (Getting Ready)"
                    onClick={(e) =>
                      history.push("/project/" + state.projectDetail.id + "/")
                    }
                  />
                </ListItem>
                <ListItem button>
                  <ListItemIcon>
                    <EventNoteIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary="Schedule (Getting Ready)"
                    onClick={(e) =>
                      history.push("/project/" + state.projectDetail.id + "/")
                    }
                  />
                </ListItem>
              </List>
            </Card>
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default Project;
